<template>
    <div class="container-fluid mt-4 p-0 g-3 align-items-start input" :class="{ 'd-flex flex-column': labelTop, 'row': !labelTop }">
        <div class="p-0 d-flex align-items-center" :class="{ 'fsp14 mb8 lh20 col-12': labelTop, 'col-sm-6': !labelTop }">
            <label :for="this.id" :class="{ 'primary-grey': !labelTop }">{{this.label}}<span class='require' v-if="this.require"> *</span></label>
            <Popper v-if="this.hint" :hover="true" :id="id + '_hint'">
                <Icon name="info" size="c16" class="ml4" />
                <template #content>
                    <span>{{ this.hint }}</span>
                </template>
            </Popper>

        </div>
        <div class="d-flex align-items-center gap-2" :class="{ 'col-sm-6 p-0': !labelTop, 'col-12': labelTop }">
            <Uploader
                :class="{ 'p-0': !labelTop }"
                :id="id"
                :arr="arr"
                :dataValue="dataValue"
                :fileName="fileName"
                :maxSize="maxSize"
                :disabled="disabled"
                :needBin="needBin"
                :returnFileObject="returnFileObject"
                :single="single"
                :formats="formats"
                :border="border"
                :unvisible="unvisible"
                :unvisibleDataValue="unvisibleDataValue"
                :is_public="is_public"
                :vMark="vMark"
                :verification="verification"
                :fileInfoText="fileInfoText"
                @updateParentState="this.updateParentState"
            />  
        </div>
    </div> 
</template>

<script>
import Lib from '@/includes/lib.js';
import SwitchSimple from '@/components/service/SwitchSimple';
import Tooltip from '@/components/service/Tooltip';
import Icon from '@/components/icons/Icon';
import Popper from '@/components/service/Popper';
import Uploader from '@/components/service/Uploader';

export default {
    components: {
        Tooltip,
        SwitchSimple,
        Icon,
        Popper,
        Uploader
    },
    data() {
        return {
            file: this.dataValue && !this.arr ? this.getDataValue(this.dataValue, this.fileName ? this.fileName : 'n') : '',
            unvisibleValue: this.unvisibleDataValue ? this.unvisibleDataValue : '',
            files: [],
            image: '',
            type: '',
            name: this.fileName ? this.fileName : false,
            knownFormats: [
                'image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'application/pdf', "application/vnd.ms-excel", 
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "text/csv", 'image/svg+xml',
                "text/xml", 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                "application/vnd.openxmlformats-officedocument.wordprocessingml.template", "application/vnd.ms-word.document.macroEnabled.12",
            ]
        }
    },
    props: {
        id: [String, Boolean],
        label: [String],
        arr: {
            type: [Boolean],
            default: false,
        },
        needBin: {
            type: [Boolean],
            default: false,
        },
        returnFileObject: [Boolean],
        single: [Boolean],
        hint: [String],
        dataValue: [String, Boolean, Object],
        fileName: [String, Boolean],
        require: [Boolean],
        verification: [String, Boolean],
        formats: [Array, Boolean],
        border: [String, Boolean],
        unvisible: [Boolean],
        disabled: [String, Boolean], 
        unvisibleDataValue: [String, Boolean], 
        is_public: [Boolean, String],
        vMark: [Boolean],
        maxSize: [Number, Boolean],
        labelTop: [Boolean],
        fileInfoText: [Boolean],
    },
    created() {
        if (this.file) {
            this.convertFile();
        }
        if (this.arr && this.dataValue) {
            this.files = this.dataValue;
            this.getDataValue(this.dataValue);
            // console.log('this.dataValue', this.dataValue)
        }
    },  
    mounted() {
    },
    methods: {
        getDataValue(val, name = 'undefined_name') {
            if (this.arr) {
                // console.log(this.files);
                for(let i = 0; i < this.files.length; i++) {
                    if (this.files[i].file_link) {
                        this.files[i].image = this.files[i].body;
                        this.files[i].name_base64 = this.files[i].name;
                        try {
                            this.files[i].name = atob(this.files[i].name); 
                        } catch(err) {
                            this.files[i].name = this.files[i].name; 
                        }
                    } else if (!this.files[i].image) {
                        this.getBase64Arr(this.objectToFile(this.files[i]), i);
                    }
                }
            } else {
                if (typeof val == 'object') {
                    return this.objectToFile(val);
                } else if (typeof val == 'string') {
                    return this.dataURLtoFile(val, name);
                } else {
                    return '';
                } 
            }
        },
        setUnvisibleValue(arg) {
            this.$emit('updateParentState', {
                id: arg.id.replace(/_switch_id/, ''),
                unvisible: true,
                value: arg.value
            })
        },
        // Потом нужно убрать как будут массивы
        convertFile() {
            if (this.file.type == 'image/jpeg' || this.file.type == 'image/jpg' || this.file.type == 'image/png' || this.file.type == 'image/svg+xml') {
                this.type = this.file.type;
                this.getBase64()
            } else if (this.file.type == 'application/pdf') {
                this.type = this.file.type;
                this.name = this.file.name;
                this.getBase64()
            }else {
                alert(`${this.$t('components.service.File.3')} ${this.file.type}`) 
            }
        },
        convertFileInArray(file, id) {
            if (Lib.inArray(file.type, this.knownFormats)) {
                this.getBase64Arr(file, id);
            } else {
                alert(`${this.$t('components.service.File.3')} ${file.type}`) 
            }
        },
        getBase64Arr(file, i) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                let res = {};
                res.name = file.name;
                res.type = file.type;
                res.size = file.size;
                if (this.needBin) {
                    res.full_result = reader.result;
                }
                if (this.returnFileObject) {
                    res.fileObject = document.querySelector(`#index_${i}`).files
                }
                res.body = reader.result.split(',')[1];
                if (Lib.inArray(file.type, ['image/jpeg', 'image/jpg', 'image/png', 'image/bmp', 'image/gif', 'image/svg+xml'])) {
                    res.image =  reader.result;
                } else {
                    res.image =  '';
                }
                // this.setValue();
                if (this.single) {
                    this.files = [res];
                } else {
                    this.files[i] = res;
                }
                this.setArrValue({id: this.id, files: this.files});
            };
            reader.onerror = function (error) {
                alert(error);
                return false;
                
            };
        },
        deleteFile(ind) {
            this.files.splice(ind, 1);
            this.setArrValue({id: this.id, files: this.files});
        },
        getBase64() {
            var reader = new FileReader();
            reader.readAsDataURL(this.file);
            reader.onload = () => {
                this.file = reader.result;
                if (this.type == 'application/pdf') {
                    this.image = ''
                } else {
                    this.image = reader.result;
                }
                this.setValue();
            };
            reader.onerror = function (error) {
                this.file = false;
                this.image = false; 
                this.setValue(); 
            };
        },
        dataURLtoFile(dataurl, filename) {
            // console.log(dataurl);
            var arr = dataurl.split(',');
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            u8arr = new Uint8Array(n);
     
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
 
            return new File([u8arr], filename, {type:mime});
        },
        objectToFile(obj) {
            let mime = obj.mime,
            bstr = atob(obj.body),
            n = bstr.length,
            u8arr = new Uint8Array(n);
     
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
 
            return new File([u8arr], obj.name, {type:mime});
        },
        updateParentState(arg) {
            if(arg.hasOwnProperty('unvisible')) {
                this.setUnvisibleValue(arg);
            } else {
                this.arr ? this.setArrValue(arg) : this.setValue(arg);
            }
        },
        setValue() {
            this.$emit('updateParentState', {
                id: this.id,
                value: this.file,
            })
        },
        setArrValue(arg) {
            this.$emit('updateParentState', {
                id: arg.id,
                value: arg.value,
            })
        }
    },

}
</script>

<style lang="scss" scoped>
.input {
    font-family: 'HelveticaNeue roman';
    &-wrapper {
        position: relative;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
    }
    &-filecontainer {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        label {
            color: $color-href;
            cursor: pointer;
        }
        img {
            max-width: 10rem;
        }
        &-input {
            display: none;
        }

    }
}
.border-r {
    border-radius: 0.5rem !important;
}
.dis_file {
    color: $color-grey !important;
    cursor: default !important;
}
</style>